import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col, Label, Button } from 'reactstrap';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { Config } from '../../../config';
import { Service } from '../../../services';
import { Translate } from '../../../contexts/Language';


const getStorageDate = key => {
  const stored = localStorage.getItem(key);
  return stored ? new Date(stored) : new Date();
};

export const DepositTab = ({
  onFilter,
}) => {
  const columns = [
    {
      name: Translate('ID'),
      selector: 'invoice_id',
      sortable: true,
      width: '200px',
      cell: d => (
        <b>
#
          {d.invoice_id}
        </b>
      ),
    },
    {
      name: Translate('Date'),
      selector: 'create_time',
      sortable: true,
      width: '150px',
    },
    {
      name: Translate('Amount'),
      selector: 'paid_amount',
      sortable: true,
      width: '120px',
      cell: d => (
        <span className="badge badge-success">
          {d.paid_amount}
          {' '}
          {d.pay_currency}
        </span>
      ),
    },
    {
      name: Translate('Status'),
      selector: 'status',
      width: '120px',
      cell: d => {
        const statusColors = {
          Complete: 'success',
          Confirmed: 'info',
          Expired: 'warning',
          Invalid: 'danger',
          New: 'primary',
          Paid: 'success',
        };
        return <span className={`badge badge-${statusColors[d.status] || 'secondary'}`}>{d.status}</span>;
      },
    },
    {
      name: Translate('Transaction ID'),
      selector: 'order_id',
      width: '200px',
    },
    {
      name: Translate('Actions'),
      cell: d => (
        <Link color="info" size="sm" className="btn btn-dark btn-sm waves-effect waves-dark" to={`/payment-services/unipayment/deposit/${d.invoice_id}`}>
          {Translate('Details')}
        </Link>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '100px',
    },
  ];

  const [depositFormData, setDepositFormData] = useState({
    start: getStorageDate('uniPaymentBeginDate'),
    end: getStorageDate('uniPaymentEndDate'),
    page_size: 10,
    page_no: 1,
    is_asc: false,
    // status: -5
  });

  const [depositDataTable, setDepositDataTable] = useState({ rows: [], totalRows: 0 });
  const [loading, setLoading] = useState(false);
  const fetchDeposits = useCallback(() => {
    Config.utilities.loadingFetch();
    setLoading(true);
    const formData = { ...depositFormData };

    Service.UniPayment.QueryDeposits(formData).then(response => {
      if (response && response.data) {
        setDepositDataTable({
          rows: response.data.data.models,
          totalRows: response.data.data.totalRecords,
          ...response.data.data,
        });
      }
      Config.utilities.loadingFetch();
      setLoading(false);
    });
  }, [depositFormData]);

  const handlePageChange = page => {
    const formData = { ...depositFormData };
    formData.page = page;
    setDepositFormData(formData);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    const formData = { ...depositFormData };
    formData.limit = newPerPage;
    formData.page = page;
    setDepositFormData(formData);
  };

  const onDepositDateChange = useCallback(date => {
    if (date !== null && Array.isArray(date)) {
      setDepositFormData(prev => ({
        ...prev,
        start: date[0],
        end: date[1],
      }));
      localStorage.setItem('uniPaymentBeginDate', date[0]);
      localStorage.setItem('uniPaymentEndDate', date[1]);
    } else {
      setDepositFormData(prev => ({
        ...prev,
        start: '',
        end: '',
      }));
    }
  }, []);

  useEffect(() => { fetchDeposits(); }, [fetchDeposits]);

  return (
    <div className="p-3">
      <Row className="mb-3">
        <Col md={6}>
          <Label>{Translate('Date Range')}</Label>
          <DateRangePicker
            onChange={onDepositDateChange}
            value={[depositFormData.start, depositFormData.end]}
            className="form-control"
          />
        </Col>
        <Col md={6} className="d-flex align-items-end">
          <Button color="primary" onClick={onFilter}>
            {Translate('Filter')}
          </Button>
        </Col>
      </Row>

      <DataTableExtensions
        columns={columns}
        data={depositDataTable.rows}
        export
        print={false}
      >
        <DataTable
          columns={columns}
          data={depositDataTable.rows}
          highlightOnHover
          striped
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={depositDataTable.totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
        />
      </DataTableExtensions>
    </div>
  );
};
